import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/configPlatform/upsert/uptime.configPlatform.upsert.mutation.gql"
import { UPTIME_CONFIG_REFETCH_QUERIES } from "@/v2-backoffice-client/uptime/config/uptime.config.query"
import type {
  UptimeConfigPlatformUpsertMutation,
  UptimeConfigPlatformUpsertMutationVariables,
} from "@/v2-backoffice-client/uptime/configPlatform/upsert/__types__/uptime.configPlatform.upsert.mutation"

type Options = MutationHookOptions<
  UptimeConfigPlatformUpsertMutation,
  UptimeConfigPlatformUpsertMutationVariables
>

export function useUptimeConfigPlatformUpsertMutation(options?: Options) {
  return useMutation<
    UptimeConfigPlatformUpsertMutation,
    UptimeConfigPlatformUpsertMutationVariables
  >(mutation, {
    refetchQueries: [...UPTIME_CONFIG_REFETCH_QUERIES],
    awaitRefetchQueries: true,
    ...options,
  })
}
